import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom"; 
import { baseURL } from "../axios/common";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors
    setLoading(true); // Set loading state

    try {
      const response = await fetch(baseURL + "admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Login failed");
      }

      // Store token in localStorage
      localStorage.setItem("token", data.data.token);

      // Redirect to dashboard
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="row">
          <div className="col-md-6">
            <div className="login-img">
              <img src="assets/img/login.jpg" alt="Login" />
            </div>
          </div>
          <div className="col-md-5 m-auto">
            <div className="card card-outline card-primary">
              <div className="card-header text-center">
                <Link
                  style={{ fontWeight: 800, fontSize: 32 }}
                  to="/"
                  className="h1 text-decoration-none"
                >
                  <img src="assets/img/logo.svg" alt="Logo" className="login-logo" />
                </Link>
              </div>
              <div className="card-body">
                <p className="login-box-msg">Sign in to start your session</p>

                {error && <p className="alert alert-danger">{error}</p>}

                <form onSubmit={submitHandler}>
                  <div className="input-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email id"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-dark btn-block pt-2 pb-2 fw-600"
                      disabled={loading}
                    >
                      {loading ? "Signing In..." : "Sign In"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
